import TabelaSede from './components/tabela';
export default function Sede() {

  return (
    <>
      <TabelaSede
      />
    </>
  )
}
